import { schema } from 'normalizr';
import user from './user';

const tip = new schema.Entity('tip', {
  owner: user,
});

export default tip;
